module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_waso_yoso@2x-16915ab5d34aa78466a1ed31a3558892.webp";